import { useState, useRef } from "react";
import { Button, Spin } from "antd";
import { FileExcelOutlined, DownloadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import axios from "axios";
import config from "../../config";
import { toast } from "react-toastify";

const normalizeCode = (value) => {
  if (value == null) return "";
  let text = String(value).trim();
  if (text.endsWith(".0")) text = text.slice(0, -2);
  return text;
};

const extractPersonalIdsFromWorkbook = (workbook) => {
  const ids = [];
  for (const sheetName of workbook.SheetNames) {
    const worksheet = workbook.Sheets[sheetName];
    const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: "" });

    for (const row of json) {
      for (const cell of row) {
        const code = normalizeCode(cell);
        if (code && /^\d{8,11}$/.test(code)) {
          ids.push(code);
        }
      }
    }
  }
  return [...new Set(ids)];
};

const SAMPLE_CODES = ["1234567890", "0012345678", "9876543210"];

const downloadExampleExcel = () => {
  const worksheet = XLSX.utils.aoa_to_sheet([["کد ملی"], ...SAMPLE_CODES.map(c => [c])]);
  const workbook = XLSX.utils.book_new();
  worksheet["!cols"] = [{ wch: 12 }];
  XLSX.utils.book_append_sheet(workbook, worksheet, "کد ملی کاربران");
  XLSX.writeFile(workbook, "نمونه کد ملی.xlsx");
};

const SelectUsersExcelButton = ({ onSelected, buttonText = "بارگذاری اکسل کد ملی" }) => {
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  const handleFile = async (file) => {
    if (!file) return;

    setLoading(true);
    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data, { type: "array" });
      const personalIds = extractPersonalIdsFromWorkbook(workbook);

      if (personalIds.length === 0) {
        toast.warn(<p dir="rtl" className="font-custom">کد ملی معتبری در فایل یافت نشد.</p>);
        return;
      }
      console.log(personalIds);
      const response = await axios.post(
        `${config.apiBaseUrl}/api/Users/GetUsersByPersonalIds`,
        personalIds,
        {
          headers: { HeaderKey: config.HeaderKey, "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      const matchedUsers = response.data || [];
      if (matchedUsers.length === 0) {
        toast.warn(<p dir="rtl" className="font-custom">هیچ کاربری با کدهای ملی موجود در فایل یافت نشد.</p>);
        return;
      }

      const notFoundCount = personalIds.length - matchedUsers.length;
      if (notFoundCount > 0) {
        toast.info(<p dir="rtl" className="font-custom">{notFoundCount} کد ملی در سیستم یافت نشد و نادیده گرفته شد.</p>);
      }

      toast.success(<p dir="rtl" className="font-custom">{matchedUsers.length} کاربر از طریق اکسل انتخاب شد.</p>);
      onSelected && onSelected(matchedUsers);
    } catch (err) {
      toast.error(<p dir="rtl" className="font-custom">خطا در بارگذاری فایل اکسل</p>);
      console.error(err);
    } finally {
      setLoading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept=".xlsx,.xls,.csv"
        style={{ display: "none" }}
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) handleFile(file);
        }}
      />
      <Button
        icon={loading ? <Spin size="small" /> : <FileExcelOutlined />}
        onClick={() => inputRef.current?.click()}
        disabled={loading}
        className="font-custom"
      >
        {buttonText}
      </Button>
      <Button
        icon={<DownloadOutlined />}
        onClick={downloadExampleExcel}
        className="font-custom mr-2"
      >
        دانلود نمونه اکسل
      </Button>
    </>
  );
};

export default SelectUsersExcelButton;
